module.exports = __webpack_public_path__ + "static/media/x-royal.671b27ee.svg";